import type { DeeplinkAction } from '@carboncopyco/types';
import { isDesktop } from '@carboncopyco/utils';
import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

interface SearchParamActionItem {
  param: DeeplinkAction;
  action: (value: string) => void;
  expectedValue?: string;
  skipOnWeb?: boolean;
  shouldSkip?: boolean;
  expectedValueCallback?: (value: string) => boolean;
}

export const useSearchParamAction = ({
  param,
  action,
  expectedValue,
  skipOnWeb,
  shouldSkip,
  expectedValueCallback,
}: SearchParamActionItem) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [resultHit, setResultHit] = useState<string>();

  useEffect(() => {
    const value = searchParams.get(param);
    if ((skipOnWeb && !isDesktop()) || shouldSkip) {
      return;
    }
    const isValueMatch =
      !!value &&
      (!expectedValue || value === expectedValue) &&
      (!expectedValueCallback || expectedValueCallback(value));
    if (isValueMatch) {
      const newSearchParams = new URLSearchParams(searchParams);
      newSearchParams.delete(param);
      setSearchParams(newSearchParams.toString());
      setResultHit(value);
    }

    if (!!resultHit && !value) {
      setResultHit(undefined);
      action(resultHit?.toString());
    }
  }, [
    resultHit,
    searchParams,
    shouldSkip,
    action,
    expectedValue,
    expectedValueCallback,
  ]);
};
